import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ResetPassword from "@/pages/ResetPassword";
import Landing from "@/pages/Landing";
import ComoIndicar from "@/pages/ComoIndicar";
import { Termos, Privacidade } from "@/pages/Legal";
import CompanyDashboard from "@/pages/CompanyDashboard";
import DriverDashboard from "@/pages/DriverDashboard";
import AutonomoDashboard from "@/pages/AutonomoDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import PublicSubscribe from "@/pages/PublicSubscribe";
import PublicSubscribeSuccess from "@/pages/PublicSubscribeSuccess";

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-blue-800">Carregando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    const home = user.role === "company" ? "/empresa" : user.role === "autonomo" ? "/autonomo" : "/motorista";
    return <Navigate to={home} replace />;
  }
  return children;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Landing />;
  const home = user.role === "company" ? "/empresa" : user.role === "autonomo" ? "/autonomo" : "/motorista";
  return <Navigate to={home} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/como-indicar" element={<ComoIndicar />} />
          <Route path="/termos" element={<Termos />} />
          <Route path="/privacidade" element={<Privacidade />} />
          <Route path="/sobre" element={<Landing />} />
          <Route path="/apresentacao" element={<Landing />} />
          <Route path="/empresa/*" element={<Protected role="company"><CompanyDashboard /></Protected>} />
          <Route path="/motorista/*" element={<Protected role="driver"><DriverDashboard /></Protected>} />
          <Route path="/autonomo/*" element={<Protected role="autonomo"><AutonomoDashboard /></Protected>} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/assinar" element={<PublicSubscribe />} />
          <Route path="/assinar/sucesso" element={<PublicSubscribeSuccess />} />
          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
